"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUndoReviewAnswerEvent = exports.isAdvancedImageSearchEvent = exports.isReviewImageUpdatedEvent = exports.isFlashcardDeletedEvent = exports.isSeeTranslationEvent = exports.isPersonalImageUploadedEvent = exports.isMarkedWordAsKnownEvent = exports.isMarkedWordAsSkippedEvent = exports.isWordFlashcardsCreatedEvent = exports.isReadFlashtipEvent = exports.isCompletedPronunciationLessonEvent = exports.isMinimalPairOnboardingAnsweredEvent = exports.isUserWithoutLanguageLearnerEvent = exports.isResetLanguageDataEvent = exports.isCompletedGuidedLearningWeekEvent = exports.isCompletedGuidedLearningEvent = exports.isCompletedReviewEvent = exports.isCompletedGuidedLearningChapterEvent = exports.isVocabSetCompletedEvent = exports.isHowToDoReviewCompletedEvent = exports.isFirstLanguageSelectedEvent = void 0;
const zod_1 = require("zod");
const analytics_types_1 = require("../analytics_types");
const language_codes_types_1 = require("../language_codes_types");
const FirstLanguageSelectedEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("onb_language_selected_v05"),
});
const isFirstLanguageSelectedEvent = (v) => FirstLanguageSelectedEventSchema.safeParse(v).success;
exports.isFirstLanguageSelectedEvent = isFirstLanguageSelectedEvent;
const HowToDoReviewCompletedEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("nug_review_onboarding_completed_v05"),
});
const isHowToDoReviewCompletedEvent = (v) => HowToDoReviewCompletedEventSchema.safeParse(v).success;
exports.isHowToDoReviewCompletedEvent = isHowToDoReviewCompletedEvent;
const VocabSetCompletedEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("gen_vocab_set_complete_v05"),
    properties_language: language_codes_types_1.LanguagePairCodeSchema,
    properties_set: zod_1.z.number(),
});
const isVocabSetCompletedEvent = (v) => VocabSetCompletedEventSchema.safeParse(v).success;
exports.isVocabSetCompletedEvent = isVocabSetCompletedEvent;
const CompletedGuidedLearningChapterEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("pss_user_completed_guided_learning_chapter_v05"),
    properties_chapter: zod_1.z.number(),
});
const isCompletedGuidedLearningChapterEvent = (v) => CompletedGuidedLearningChapterEventSchema.safeParse(v).success;
exports.isCompletedGuidedLearningChapterEvent = isCompletedGuidedLearningChapterEvent;
const CompletedReviewEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("rev_session_completed_v05"),
    properties_language_code: language_codes_types_1.LanguagePairCodeSchema,
    properties_percentage_of_correct_flashcards: zod_1.z.number(),
});
const isCompletedReviewEvent = (v) => CompletedReviewEventSchema.safeParse(v).success;
exports.isCompletedReviewEvent = isCompletedReviewEvent;
const CompletedGuidedLearningEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("pss_user_completed_all_guided_learning_chapters_v05"),
});
const isCompletedGuidedLearningEvent = (v) => CompletedGuidedLearningEventSchema.safeParse(v).success;
exports.isCompletedGuidedLearningEvent = isCompletedGuidedLearningEvent;
const CompletedGuidedLearningWeekEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("pss_user_completed_guided_learning_week_v05"),
    properties_week: zod_1.z.number(),
});
const isCompletedGuidedLearningWeekEvent = (v) => CompletedGuidedLearningWeekEventSchema.safeParse(v).success;
exports.isCompletedGuidedLearningWeekEvent = isCompletedGuidedLearningWeekEvent;
const ResetLanguageDataEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("set_reset_all_data_v05"),
    properties_language: language_codes_types_1.LanguagePairCodeSchema,
});
const isResetLanguageDataEvent = (v) => ResetLanguageDataEventSchema.safeParse(v).success;
exports.isResetLanguageDataEvent = isResetLanguageDataEvent;
const UserWithoutLanguageLearnerEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("ach_user_wo_language_learner_achievement_v05"),
});
const isUserWithoutLanguageLearnerEvent = (v) => UserWithoutLanguageLearnerEventSchema.safeParse(v).success;
exports.isUserWithoutLanguageLearnerEvent = isUserWithoutLanguageLearnerEvent;
const MinimalPairOnboardingAnsweredEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("nug_minimal_pair_onboarding_answered_v05"),
});
const isMinimalPairOnboardingAnsweredEvent = (v) => MinimalPairOnboardingAnsweredEventSchema.safeParse(v).success;
exports.isMinimalPairOnboardingAnsweredEvent = isMinimalPairOnboardingAnsweredEvent;
const CompletedPronunciationLessonEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("pro_lesson_completed_v05"),
    properties_language: language_codes_types_1.LanguagePairCodeSchema,
});
const isCompletedPronunciationLessonEvent = (v) => CompletedPronunciationLessonEventSchema.safeParse(v).success;
exports.isCompletedPronunciationLessonEvent = isCompletedPronunciationLessonEvent;
const ReadFlashtipEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("nug_read_flashtip_v05"),
});
const isReadFlashtipEvent = (v) => ReadFlashtipEventSchema.safeParse(v).success;
exports.isReadFlashtipEvent = isReadFlashtipEvent;
const WordFlashcardsCreatedEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("wrd_flashcards_created_v05"),
    properties_language: language_codes_types_1.LanguagePairCodeSchema,
});
const isWordFlashcardsCreatedEvent = (v) => WordFlashcardsCreatedEventSchema.safeParse(v).success;
exports.isWordFlashcardsCreatedEvent = isWordFlashcardsCreatedEvent;
const MarkedWordAsSkippedEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("gen_word_skipped_v05"),
});
const isMarkedWordAsSkippedEvent = (v) => MarkedWordAsSkippedEventSchema.safeParse(v).success;
exports.isMarkedWordAsSkippedEvent = isMarkedWordAsSkippedEvent;
const MarkedWordAsKnownEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("gen_word_known_v05"),
});
const isMarkedWordAsKnownEvent = (v) => MarkedWordAsKnownEventSchema.safeParse(v).success;
exports.isMarkedWordAsKnownEvent = isMarkedWordAsKnownEvent;
const PersonalImageUploadedEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("gen_personal_image_uploaded_v05"),
    properties_source: zod_1.z.string(),
});
const isPersonalImageUploadedEvent = (v) => PersonalImageUploadedEventSchema.safeParse(v).success;
exports.isPersonalImageUploadedEvent = isPersonalImageUploadedEvent;
const SeeTranslationEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("rev_see_translation_v05"),
});
const isSeeTranslationEvent = (v) => SeeTranslationEventSchema.safeParse(v).success;
exports.isSeeTranslationEvent = isSeeTranslationEvent;
const FlashcardDeletedEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("rev_flashcard_deleted_v05"),
});
const isFlashcardDeletedEvent = (v) => FlashcardDeletedEventSchema.safeParse(v).success;
exports.isFlashcardDeletedEvent = isFlashcardDeletedEvent;
const ReviewImageUpdatedEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("rev_image_updated_v05"),
});
const isReviewImageUpdatedEvent = (v) => ReviewImageUpdatedEventSchema.safeParse(v).success;
exports.isReviewImageUpdatedEvent = isReviewImageUpdatedEvent;
const AdvancedImageSearchEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("gen_advanced_image_search_v05"),
});
const isAdvancedImageSearchEvent = (v) => AdvancedImageSearchEventSchema.safeParse(v).success;
exports.isAdvancedImageSearchEvent = isAdvancedImageSearchEvent;
const UndoReviewAnswerEventSchema = analytics_types_1.AnalyticsUserTrackEventSchema.extend({
    event: zod_1.z.literal("rev_answer_undone_v05"),
});
const isUndoReviewAnswerEvent = (v) => UndoReviewAnswerEventSchema.safeParse(v).success;
exports.isUndoReviewAnswerEvent = isUndoReviewAnswerEvent;
//# sourceMappingURL=achievements_analytics_events_types.js.map